import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  static targets = ["input", "checkbox"];

  declare readonly inputTarget: HTMLInputElement;
  declare readonly checkboxTarget: HTMLInputElement;

  format() {
    const formattedValue = this.#formatNumber(this.inputTarget.value);

    this.inputTarget.value = formattedValue;
    this.inputTarget.dataset.currentValue = formattedValue;
  }

  toggleUnlimited() {
    if (this.checkboxTarget.checked) {
      this.inputTarget.value = "Infinity";
    } else {
      this.inputTarget.value = this.#formatNumber(this.inputTarget.dataset.currentValue || "");
    }

    if (this.inputTarget.form) {
      this.inputTarget.form.dispatchEvent(new Event("input"));
    }
  }

  #formatNumber(value: string) {
    const numericValue = value.replace(/[^0-9.]/g, "");
    return Number(numericValue).toLocaleString();
  }
}
